export const COLORS = {
    yellowLight: '#BD9806',
    yellow: '#ffcc00',
    blueMenu: '#001529',
    darkBlue: '#1a2a3a',
    blue2a3a4a: '#2a3a4a',
    blue3a4a5a: '#3a4a5a',
    blue5a6a7a: '#5a6a7a',
    blue6a7a8a: '#6a7a8a',
    lightBlue: '#7a8a9a',
    red: '#f95d53',
    redClose: '#ff8888',
    redFail: '#ff5588', 
    greenSuccess: '#20c959',
    darkGreen: '#27ae60',
    greenBG: '#73b233',
    lightgreen: '#8DCB4F',
    greyButton: '#acb8c3',
    greya3: '#a3a3a3',
    greyaaa: '#aaa',
    greybbb: '#bbb',
    cccWhite: '#ccc',
    eeeWhite: '#eee',
    white: '#fff',
    whiteFa: '#fafafa',
    whiteFdf9: '#fdf9f9',
    purple: '#8C81AE',
};

export const STRINGS = {
    userLine1Web: 'ONLY THE LATEST MOVIES\nBROUGHT TO YOU DIRECTLY BY THEIR PRODUCERS\nNO MONTHLY SUBSCRIPTIONS\nJUST BUY A ',
    userLine2Web: ' FOR THE MOVIE YOU LIKE',
    userLine1: 'ONLY THE LATEST MOVIES\n',
    userLine2: '\nBROUGHT TO YOU DIRECTLY BY THEIR PRODUCERS\n',
    userLine3: '\nNO MONTHLY SUBSCRIPTIONS\n',
    userLine4: '\nJUST BUY A TICKET FOR THE MOVIE YOU LIKE',
    launchStr: 'Know When We Launch',
    madeFor: 'MADE \nFOR \nPRODUCERS',
    madeForIndie: 'THE OVERSEAS STREAMING PLATFORM\nMADE FOR PRODUCERS\nINDIE & LARGE',
    point1: 'Hit.Movie is a self publishing platform for Movie Producers.',
    point2: 'Get your movie in front of audiences in 150+ countries in as less as 7 days.',
    point3: 'Producers make 70% of all ticket revenue.',
    point4: 'Ticket revenue is immediately transferred to your connected bank account.',
    point5: 'DRM + Geo Fencing protection by default.',
    simpleStr: "IT'S THAT SIMPLE",
    securityStr: 'Hit.Movie compresses everything needed to screen a movie into a standard Apple TV Box. It does this without compromising the security and delivery specifications of current digital cinema.',
    bankAccountStr: 'Hit.Movie is currently available in,\nAustralia, Europe, North America, India, Singapore, Japan, and New Zealand.\nSome features may not be available in some regions.\nListing fees apply. Rights of admission reserved. Read all terms ',
    contriesList: 'All names, logos, brands are property of their respective owners.\nUse of these names, logos, brands does not imply endorsement.',
    readTerms: 'Listing fees apply. Rights of admission reserved. Please read all terms ',
    ratingUrl: 'https://docs.hit.movie/self-regulation',
    streamQualityUrl: 'https://docs.hit.movie/stream-quality',
    termsUrl: 'https://docs.hit.movie/services-and-privacy-terms',
    aboutUrl: 'https://docs.hit.movie/',
    whyUrl: 'https://docs.hit.movie/why',
    contactUrl: 'https://docs.hit.movie/support',
    statusUrl: 'https://stats.uptimerobot.com/1w9AMipDMG',
    streamingUrl: 'https://docs.hit.movie/worldwide-streaming',
    compatibilityMatrixUrl: 'https://docs.hit.movie/stream-quality#compatibility-matrix',
    paymentStr: "After payment, you will be able to add all movie details below, \nsecurely upload your movie files, and setup your banking information for \nHit.Movie to process your share of ticket revenue.",
    listingStr: "New movie listings take atleast 7 days to process. \nHowever we recommend you plan your release process at least 14 days in advance. \nYou can start the process by filling in your basic details and paying the movie listing fees below.",
};

export const countriesList = {
    'Australia': 'AU',
    'Austria': 'AT',
    'Belgium': 'BE',
    'Bulgaria': 'BG',
    'Brazil ': 'BR',
    'Canada': 'CA',
    'Cyprus': 'CY',
    'Czech Republic': 'CZ',
    'Denmark': 'DK',
    'Estonia': 'EE',
    'Finland': 'FI',
    'France': 'FR',
    'Germany': 'DE',
    'Greece': 'GR',
    'Hong Kong': 'HK',
    'Hungary': 'HU',
    'India': 'IN',
    'Ireland': 'IE',
    'Italy': 'IT',
    'Japan': 'JP',
    'Latvia': 'LV',
    'Lithuania': 'LT',
    'Luxembourg': 'LU',
    'Malaysia': 'MY',
    'Malta': 'MT',
    'Mexico ': 'MX',
    'Netherlands': 'NL',
    'New Zealand': 'NZ',
    'Norway': 'NO',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Romania': 'RO',
    'Singapore': 'SG',
    'Slovakia': 'SK',
    'Slovenia': 'SI',
    'Spain': 'ES',
    'Sweden': 'SE',
    'Switzerland': 'CH',
    'United Kingdom': 'GB',
    'United States': 'US'      
};

export const languageList = {
    af: 'Afrikaans',
    am: 'Amharic',
    ar: 'Arabic',
    az: 'Azerbaijani',
    be: 'Belorussian',
    bg: 'Bulgarian',
    bn: 'Bengali',
    bs: 'Bosnian',
    ca: 'Catalan',
    cs: 'Czech',
    da: 'Danish',
    de: 'German',
    dv: 'Dhivehi',
    en: 'English',
    es: 'Spanish',
    et: 'Estonian',
    eu: 'Basque',
    fa: 'Persian',
    fi: 'Finnish',
    fr: 'French',
    gl: 'Galician',
    el: 'Greek',
    ha: 'Hausa',
    he: 'Hebrew',
    hi: 'Hindi',
    hr: 'Croatian',
    hu: 'Hungarian',
    hy: 'Armenian',
    is: 'Icelandic',
    it: 'Italian',
    id: 'Indonesian',
    ja: 'Japanese',
    ka: 'Georgian',
    kk: 'Kazakh',
    km: 'Khmer',
    ko: 'Korean',
    ku: 'Kurdish',
    ky: 'Kyrgyz',
    lt: 'Lithuanian',
    lv: 'Latvian',
    mk: 'Macedonian',
    ml: 'Malayalam',
    mn: 'Mongolian',
    ms: 'Malay',
    nb: 'Norwegian Bokmål',
    nl: 'Dutch',
    nn: 'Norwegian Nynorsk',
    no: 'Norwegian',
    pl: 'Polish',
    ps: 'Pashto',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russian',
    sd: 'Sindhi',
    sk: 'Slovak',
    sl: 'Slovene',
    so: 'Somali',
    sq: 'Albanian',
    sr: 'Serbian',
    sv: 'Swedish',
    sw: 'Swahili',
    ta: 'Tamil',
    tg: 'Tajik',
    th: 'Thai',
    tr: 'Turkish',
    tt: 'Tatar',
    ug: 'Uyghur',
    uk: 'Ukrainian',
    ur: 'Urdu',
    uz: 'Uzbek',
    zh: 'Chinese',
    vi: 'Vietnamese'      
};
